var CouponCodesEnum = /*#__PURE__*/function (CouponCodesEnum) {
  CouponCodesEnum["NP_GOLD_DD"] = "NP-GOLD-DD";
  CouponCodesEnum["NP_GOLD_MP"] = "NP-GOLD-MP";
  CouponCodesEnum["NP_GOLD_CB"] = "NP-GOLD-CB";
  CouponCodesEnum["NP_GOLD_FB"] = "NP-GOLD-FB";
  CouponCodesEnum["NP_GOLD_MT"] = "NP-GOLD-MT";
  CouponCodesEnum["NP_GOLD_Q"] = "NP-GOLD-Q";
  return CouponCodesEnum;
}(CouponCodesEnum || {});
var CouponCodesEnum$1 = CouponCodesEnum;

export { CouponCodesEnum$1 as default };
//# sourceMappingURL=CouponCodesEnum.js.map
